/* eslint-disable camelcase */
const en = {
  common: {
    copied: 'Copied',
    course: {
      zero: '%{courses_capitalized}',
      one: '%{course_capitalized}',
      other: '%{courses_capitalized}'
    },
    follower: {
      zero: 'Followers',
      one: 'Follower',
      other: 'Followers'
    },
    leader: {
      zero: 'Leaders',
      one: 'Leader',
      other: 'Leaders'
    }
  },
  joi: {
    fields: {
      date_of_birth: 'Date of birth',
      email: 'Email address',
      partner_email: 'Partner email address',
      first_name: 'First name',
      last_name: 'Last name',
      phone: 'Phone',
      student: '%{member_capitalized}',
      role: 'Role',
      partner_gegevens: 'Partner details',
      woonplaats: 'City',
      hoe_heb_je_ons_gevonden: 'How did you find us?',
      fields_name: 'Field name',
      fields_id: 'Field ID',
      fields_type: 'Field type',
      fields_mandatory: 'Mandatory',
      fields_category: 'Category',
      fields_value: '%{name}',
    },
    templates: {
      base: '%{field} %{message}'
    },
    string: {
      base: 'should be a string.',
      empty: 'is not allowed to be empty',
      min: 'should contain at least %{number} characters.',
      max: 'should contain at most %{number} characters.',
      length: 'is not the specified exact length.',
      email: 'is not a valid email.',
      regex: {
        base: 'does not match the specified regular expression.'
      },
      restricted_email: 'of partner cannot be the same as purchaser.',
      invalid_email: 'is invalid.'
    },
    number: {
      base: 'should be a number.',
      min: 'is smaller than the specified minimum.',
      max: 'is larger than the specified maximum.',
      integer: 'is not an integer.'
    },
    date: {
      base: 'is not a valid date.',
      min: 'is before the specified minimum date.',
      max: 'is after the specified maximum date.'
    },
    boolean: {
      base: 'is not a boolean.'
    },
    array: {
      base: 'is not an array.',
      min: 'has fewer items than the specified minimum.',
      max: 'has more items than the specified maximum.'
    },
    object: {
      base: 'is not an object.',
      unknown: 'contains fields that are not allowed.'
    },
    any: {
      invalid: 'contains an invalid token.',
      required: 'was not provided.',
      only: 'does not match any of the allowed values.'
    }
  },
  installments: {
    delete_failed: 'The row could not be removed. Please try again.'
  },
  mailings: {
    editor: {
      first_name: 'First name',
      last_name: 'Last name',
      placeholders: 'Placeholders'
    }
  },
  payment_form: {
    on_waitlist: 'On waitlist',
    people_waiting: {
      one: '1 person on the waitlist',
      other: '%{count} people on the waitlist'
    },
    discount_code: {
      check: 'Check'
    },
    payments: {
      new: {
        alerts: {
          select_bank: 'Please select your bank',
          select_plan: 'Please select your plan',
          agree_terms: 'Please agree to the terms'
        },
        ideal_terms: 'I agree to deduct %{amount} from my IBAN every new period.',
        credit_card_terms: 'I agree to deduct %{amount} from my credit card every new period.'
      }
    },
    utils: {
      texts: {
        available: 'Available',
        select_course: 'Select %{number} %{object} you want to follow',
        student_explanatory: 'Please add your details',
        student_explanatory_student: 'Child\'s details (the %{member})',
        partner_explanatory: 'Please add partner details',
        partner_explanatory_student: 'Partner details',
        spots_left: {
          zero: '0 spots left',
          one: '1 spot left',
          other: '%{count} spots left'
        },
        starts_on: 'Starts on',
        trial_class: '%{trial_class_capitalized}',
        waitlist: 'Join waitlist',
        waitlisted: 'At this moment it is not possible to enroll as %{role1}, ' +
                    'because we strive to keep the %{class} in balance. ' +
                    'A spot will become available as soon as a new %{role2} enrolls.',
        couple_available: 'Available as couple',
        couple_not_available: 'Not available',
        couple_leader_title: 'Your details',
        couple_leader_explanatory: 'Enter your details as Leader',
        couple_follower_title: 'Partner details',
        couple_follower_explanatory: 'Enter the Follower details',
      }
    },
    errors: {
      no_more_spots: 'Sorry, no more spots left',
      no_spots_left_for: 'Sorry, no spots left for %{role}',
      no_dance_class_selected: 'Please select at least one %{course} or click \'Choose later\''
    }
  }
};
/* eslint-enable camelcase */

export default en;
